export const LOSEndpoints = [
  {
    baseUrl: "seulah",
    name: "customer/loanTypeFormula/applyLoanValidation",
    alias: "applyLoanValidation",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/clearance/certificate/generate",
    alias: "generate",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/alrajhi/transfer/transferOut",
    alias: "transferOut",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loan/application/reject",
    alias: "reject",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/alrajhi/transfer/fetchUserTransactions",
    alias: "fetchUserTransactions",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loanType/getAllLoanType",
    alias: "getAllLoanType",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loanType/getSingleLoanType",
    alias: "getSingleLoanType",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/term/rates/calculate",
    alias: "calculate",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/alrajhi/createVirtualAccount",
    alias: "createVirtualAccount",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loanTypeFormula/applyLoan",
    alias: "applyLoan",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loan/application/detailsWithHistory",
    alias: "detailsWithHistory",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/bankCode",
    alias: "bankCode",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/aml/ibanValidate",
    alias: "ibanValidate",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loanTypeFormula/flagStatusChange",
    alias: "flagStatusChange",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/alrajhi/getVirtualAccount",
    alias: "getVirtualAccount",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loan/application/details",
    alias: "detailsLos",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/user/bank",
    alias: "bank",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loan/application/list",
    alias: "list",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/loanApplication/checkUserHasApplications",
    alias: "checkUserHasApplications",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/simah/getSimahCreditBureau",
    alias: "getSimahCreditBureau",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "term/rates/aprcalculation",
    alias: "aprcalculation",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/aml/duplicateIban",
    alias: "duplicateIbanLos",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/simah/finalInquiry",
    alias: "finalInquiry",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },
  {
    baseUrl: "seulah",
    name: "customer/arb/payment-gateway/init-payment",
    alias: "initPayment",
    path: "los",
    noToken: true,
    runAt: "onDemand",
  },

]

export const LOSEndpointsMapping = {
  ApplyLoanValidation: 'applyLoanValidation',
  Generate: 'generate',
  TransferOut: 'transferOut',
  Reject: 'reject',
  FetchUserTransactions: 'fetchUserTransactions',
  GetAllLoanType: 'getAllLoanType',
  GetSingleLoanType: 'getSingleLoanType',
  Calculate: 'calculate',
  CreateVirtualAccount: 'createVirtualAccount',
  ApplyLoan: 'applyLoan',
  DetailsWithHistory: 'detailsWithHistory',
  BankCode: 'bankCode',
  IbanValidate: 'ibanValidate',
  FlagStatusChange: 'flagStatusChange',
  GetVirtualAccount: 'getVirtualAccount',
  DetailsLos: 'detailsLos',
  Bank: 'bank',
  List: 'list',
  CheckUserHasApplications: 'checkUserHasApplications',
  GetSimahCreditBureau: 'getSimahCreditBureau',
  Aprcalculation: 'aprcalculation',
  DuplicateIbanLos: 'duplicateIbanLos',
  FinalInquiry: 'finalInquiry',
  InitPayment: "initPayment"
}